<!-- Mobile Overlay -->
<div *ngIf="menuService.showMobileMenu"
  class="fixed inset-0 bg-slate-900/50 backdrop-blur-sm z-[49] lg:hidden transition-opacity duration-300"
  (click)="closeMobileMenu()">
</div>

<aside [ngClass]="[
    'fixed inset-y-0 left-0 z-[50] h-screen transition-all duration-300 border-r flex flex-col overflow-hidden',
    'bg-gradient-to-b from-[#161d2e] via-[#1C2434] to-[#151b29] border-slate-800/80',
    !menuService.showMobileMenu ? '-translate-x-full lg:translate-x-0' : 'translate-x-0',
    menuService.showSideBar ? 'lg:w-[260px] w-[300px]' : 'lg:w-[80px] w-[300px]'
  ]">

  <!-- BRAND / LOGO -->
  <div class="px-5 py-6 border-b border-slate-800/60 relative z-10 flex items-center"
    [class.justify-between]="menuService.showSideBar || menuService.showMobileMenu"
    [class.justify-center]="!menuService.showSideBar && !menuService.showMobileMenu">
    @if (menuService.showSideBar || menuService.showMobileMenu) {
    <a [routerLink]="user()?.plateform === 'BACKOFFICE_ADMIN' ? '/admin' : '/company'" class="flex items-center gap-3">
      <img src="/assets/images/LogoPrimeJaune.png" class="w-28 object-contain" alt="Logo" />
    </a>
    <button *ngIf="menuService.showMobileMenu" (click)="closeMobileMenu()"
      class="p-2 rounded-lg text-slate-400 hover:text-white hover:bg-white/10 transition-colors lg:hidden" title="Fermer le menu">
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <line x1="18" y1="6" x2="6" y2="18"></line>
        <line x1="6" y1="6" x2="18" y2="18"></line>
      </svg>
    </button>
    } @else {
    <div class="flex flex-col items-center gap-4">
      <a [routerLink]="user()?.plateform === 'BACKOFFICE_ADMIN' ? '/admin' : '/company'">
        <img src="assets/prime.ico.png" class="w-8 h-8" alt="P" />
      </a>
      <button (click)="menuService.showSideBar = !menuService.showSideBar"
        class="p-2 rounded-lg text-slate-400 hover:text-white hover:bg-white/10 transition-colors" title="Agrandir le menu">
        <i data-feather="chevrons-right" class="h-4 w-4"></i>
      </button>
    </div>
    }
  </div>

  <!-- Menu principal -->
  <div class="flex flex-col h-full overflow-y-auto mt-5 px-3.5 no-scrollbar z-10">
    <h3 *ngIf="menuService.showSideBar || menuService.showMobileMenu"
      class="text-slate-500 text-[10px] font-bold mb-3 px-3 uppercase tracking-[0.18em]">
      MENU</h3>

    <div class="space-y-1" *ngFor="let menu of filteredMenu()">
      <ul class="flex flex-col gap-0.5 w-full" role="list">
        @for (item of menu.items; track item.label) {
        @if (hasItemPermission(item)) {
        <li class="relative group" role="none">
          <!-- Navigable Item -->
          <a *ngIf="item.route"
            class="nav-item relative w-full flex items-center px-3.5 py-2.5 rounded-xl transition-all duration-200 cursor-pointer"
            [routerLink]="item.route" routerLinkActive="active-menu-item" [routerLinkActiveOptions]="{ exact: true }"
            (click)="onMenuItemClick()">

            <span class="nav-item-icon flex items-center justify-center shrink-0">
              <i attr.data-feather="{{ item.icon }}" class="h-4 w-4"></i>
            </span>
            <span *ngIf="menuService.showSideBar || menuService.showMobileMenu"
              class="text-[12.5px] font-medium ml-3 truncate">{{ item.label }}</span>

            <span *ngIf="menuService.showSideBar || menuService.showMobileMenu" class="ml-auto flex items-center gap-2">
              <!-- Notifications -->
              @if (item.label === "Salariés" && (notifMetric[0].value || notifMetric[2].value)) {
                @if (this.user()?.plateform === "BACKOFFICE_ADMIN") {
                  <span
                    class="inline-flex items-center justify-center min-w-[22px] h-5 px-1.5 rounded-full bg-red-500 text-white text-[10px] font-bold shadow-sm shadow-red-500/30">
                    {{ notifMetric[0].value + notifMetric[2].value }}+
                  </span>
                } }
              @if (item.label === "Fonds" && notifMetric[1].value && !item.expanded) {
                <span
                  class="inline-flex items-center justify-center min-w-[20px] h-5 px-1.5 rounded-full bg-red-500 text-white text-[10px] font-bold shadow-sm shadow-red-500/30">
                  {{ notifMetric[1].value }}
                </span>
              }
              @if (item.label === "E-commerce" && pendingEcommerceOrdersCount > 0 && !item.expanded) {
                <span
                  class="inline-flex items-center justify-center min-w-[20px] h-5 px-1.5 rounded-full bg-red-500 text-white text-[10px] font-bold shadow-sm shadow-red-500/30">
                  {{ pendingEcommerceOrdersCount }}
                </span>
              }
              @if(item.label === "Plafond" && notifMetric[2].value && !item.expanded){
                <span
                  class="inline-flex items-center justify-center min-w-[20px] h-5 px-1.5 rounded-full bg-red-500 text-white text-[10px] font-bold shadow-sm shadow-red-500/30">
                  {{ notifMetric[2].value }}
                </span>
              }
              @if(item.label === "Compte Bon" && notifMetric[3].value && !item.expanded){
                <span
                  class="inline-flex items-center justify-center min-w-[20px] h-5 px-1.5 rounded-full bg-red-500 text-white text-[10px] font-bold shadow-sm shadow-red-500/30">
                  {{ notifMetric[3].value }}
                </span>
              }
              @if(item.label === "Transferts Internes" && notifMetric[4].value && !item.expanded){
                <span
                  class="inline-flex items-center justify-center min-w-[20px] h-5 px-1.5 rounded-full bg-red-500 text-white text-[10px] font-bold shadow-sm shadow-red-500/30">
                  {{ notifMetric[4].value }}
                </span>
              }
              @if(item.label === "Marchands" && notifMetric[5].value && !item.expanded){
                <span
                  class="inline-flex items-center justify-center min-w-[20px] h-5 px-1.5 rounded-full bg-red-500 text-white text-[10px] font-bold shadow-sm shadow-red-500/30">
                  {{ notifMetric[5].value }}
                </span>
              }

              <!-- Toggle arrow for items with children -->
              @if (item.children && hasAnyChildPermission(item)) {
                <i data-feather="chevron-down" [ngClass]="{'rotate-180': item.expanded}"
                  class="h-4 w-4 transition-transform duration-200 text-slate-500"></i>
              }
            </span>
          </a>

          <!-- Submenu Toggle (for items without direct route but has children) -->
          <div *ngIf="!item.route && hasAnyChildPermission(item)"
            class="nav-item relative w-full flex items-center px-3.5 py-2.5 rounded-xl transition-all duration-200 cursor-pointer"
            (click)="toggleMenu(item)">
            <span class="nav-item-icon flex items-center justify-center shrink-0">
              <i attr.data-feather="{{ item.icon }}" class="h-4 w-4"></i>
            </span>
            <span *ngIf="menuService.showSideBar || menuService.showMobileMenu"
              class="text-[12.5px] font-medium ml-3 truncate">{{ item.label }}</span>

            <span *ngIf="menuService.showSideBar || menuService.showMobileMenu" class="ml-auto flex items-center gap-2">
              @if (item.label === "Fonds" && notifMetric[1].value && !item.expanded) {
                <span
                  class="inline-flex items-center justify-center min-w-[20px] h-5 px-1.5 rounded-full bg-red-500 text-white text-[10px] font-bold shadow-sm shadow-red-500/30">
                  {{ notifMetric[1].value }}
                </span>
              }
              @if (item.label === "E-commerce" && pendingEcommerceOrdersCount > 0 && !item.expanded) {
                <span
                  class="inline-flex items-center justify-center min-w-[20px] h-5 px-1.5 rounded-full bg-red-500 text-white text-[10px] font-bold shadow-sm shadow-red-500/30">
                  {{ pendingEcommerceOrdersCount }}
                </span>
              }
              <i data-feather="chevron-down" [ngClass]="{'rotate-180': item.expanded}"
                class="h-4 w-4 transition-transform duration-200 text-slate-500"></i>
            </span>
          </div>

          <!-- Submenu -->
          @if (item.expanded && hasAnyChildPermission(item)) {
          <app-sidebar-submenu [submenu]="item" [deposits]="notifMetric[1].value || 0"
            [pendingEcommerceOrders]="pendingEcommerceOrdersCount"></app-sidebar-submenu>
          }
        </li>
        }
        }
      </ul>
    </div>
  </div>

  <!-- Footer utilisateur -->
  <div class="mt-auto p-3 border-t border-slate-800/60" *ngIf="menuService.showSideBar || menuService.showMobileMenu">
    <div class="flex items-center gap-3 rounded-xl bg-white/[0.04] ring-1 ring-white/[0.06] px-3 py-2.5">
      <div class="w-9 h-9 rounded-full ring-2 ring-brand-primary/60 p-0.5 shrink-0 bg-slate-800">
        <img [src]="userAuth().avatarPath || '/assets/images/user5.jpg'" class="w-full h-full rounded-full object-cover"
          alt="Avatar" />
      </div>
      <div class="flex flex-col min-w-0">
        <span class="text-white text-[13px] font-semibold truncate leading-tight">{{ userAuth().firstname }} {{
          userAuth().lastname }}</span>
        <span class="text-slate-400 text-[11px] truncate mt-0.5">{{ userAuth().role?.name }}</span>
      </div>
      <button (click)="logout()" title="Déconnexion"
        class="ml-auto p-2 rounded-lg text-slate-400 hover:text-red-400 hover:bg-red-500/10 transition-colors shrink-0">
        <i data-feather="log-out" class="h-4 w-4"></i>
      </button>
    </div>
  </div>

  <!-- Collapsed Footer -->
  <div class="mt-auto py-6 flex justify-center border-t border-slate-800/60"
    *ngIf="!menuService.showSideBar && !menuService.showMobileMenu">
    <div class="w-10 h-10 rounded-full ring-2 ring-brand-primary/60 p-0.5 bg-slate-800">
      <img [src]="userAuth().avatarPath || '/assets/images/user5.jpg'" class="w-full h-full rounded-full object-cover"
        alt="Avatar" />
    </div>
  </div>
</aside>
